import React from 'react';
import { Wrapper } from './style';
export default ({ children }) => <Wrapper>{children}</Wrapper>;
